// extracted by mini-css-extract-plugin
export default {"container":"vZ-z","heading":"wZ-z","links":"xZ-z","copy":"yZ-z","subCopy":"zZ-z","linksLeft":"AZ-z","linksCenter":"BZ-z","linksRight":"CZ-z","link":"DZ-z","onlyLink":"EZ-z"};